<template>
  <v-card
    flat
    class="pa-3 mt-2"
  >
    <v-form
      ref="form"
      v-model="valid"
      @submit.prevent="update"
    >
      <v-card-text class="pb-0">
        <v-card-title>
          <v-icon
            size="26"
            class="text--primary me-3"
          >
            {{ icons.mdiShieldLock }}
          </v-icon>
          <span>Segurança</span>
        </v-card-title>

        <v-row class="mt-3">
          <v-col
            cols="12"
            sm="8"
            md="6"
          >
            <!-- new password -->
            <v-text-field
              v-model="accountDataLocale.senha"
              :type="isNewPasswordVisible ? 'text' : 'password'"
              :append-icon="isNewPasswordVisible ? icons.mdiEyeOffOutline:icons.mdiEyeOutline"
              label="Nova senha"
              :rules="[validators.passwordValidator]"
              outlined
              dense
              hint="Mínimo 8 caracteres e máximo 40."
              persistent-hint
              @click:append="isNewPasswordVisible = !isNewPasswordVisible"
            ></v-text-field>

            <!-- confirm password -->
            <v-text-field
              v-model="senhaConfirmacao"
              :type="isCPasswordVisible ? 'text' : 'password'"
              :append-icon="isCPasswordVisible ? icons.mdiEyeOffOutline:icons.mdiEyeOutline"
              label="Confirme a nova senha"
              :rules="[validators.required, validators.passwordValidator, validators.confirmedValidator(accountDataLocale.senha, senhaConfirmacao)]"
              outlined
              dense
              class="mt-3"
              @click:append="isCPasswordVisible = !isCPasswordVisible"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>

      <v-col cols="12">
        <v-btn
          v-if="acessoPut"
          color="primary"
          class="ml-2 mb-2 me-3 mt-4"
          type="submit"
        >
          Salvar alterações
        </v-btn>
        <v-btn
          v-else
          color="primary"
          class="ml-2 mb-2 me-3 mt-4"
          disabled
        >
          Salvar alterações
        </v-btn>
        <v-btn
          color="secondary"
          outlined
          class="mb-2 mt-4"
          type="reset"
          @click.prevent="resetForm"
        >
          Cancelar
        </v-btn>
      </v-col>
    </v-form>
  </v-card>
</template>

<script>
// eslint-disable-next-line object-curly-newline
import { alphaValidator, confirmedValidator, emailValidator, passwordValidator, required } from '@core/utils/validation'
import {
  mdiShieldLock, mdiEyeOffOutline, mdiEyeOutline, mdiKeyOutline, mdiLockOpenOutline,
} from '@mdi/js'
import { ref } from '@vue/composition-api'
import Vue from 'vue'
import ColaboradorService from '@/services/modules/ColaboradorService'

export default {
  props: {
    securityData: {
      type: Object,
      default: () => {},
    },
    acessoPut: {
      type: Boolean,
      default: true,
    },
  },

  setup(props) {
    const accountDataLocale = ref(JSON.parse(JSON.stringify(props.securityData)))
    const senhaConfirmacao = ref('')

    const isNewPasswordVisible = ref(false)
    const isCPasswordVisible = ref(false)

    const form = ref(null)
    const valid = ref(false)
    const loading = ref(false)

    const resetForm = () => {
      accountDataLocale.value = JSON.parse(JSON.stringify(props.securityData))
      accountDataLocale.value.senha = ''
      senhaConfirmacao.value = ''
      form.value.resetValidation()
    }

    const update = () => {
      form.value.validate()
      if (!valid.value) return

      loading.value = true

      const { id } = accountDataLocale.value
      const data = { senha: accountDataLocale.value.senha }

      if (!id) {
        Vue.$toast.error('ID do usuário não encontrado.')
        loading.value = false
        return
      }

      ColaboradorService.update(id, data)
        .then(() => {
          resetForm()
        })
        .finally(() => {
          loading.value = false
        })
    }

    return {
      accountDataLocale,
      senhaConfirmacao,
      isNewPasswordVisible,
      isCPasswordVisible,
      form,
      valid,
      loading,

      resetForm,
      update,

      icons: {
        mdiShieldLock,
        mdiKeyOutline,
        mdiLockOpenOutline,
        mdiEyeOffOutline,
        mdiEyeOutline,
      },
      validators: {
        confirmedValidator,
        required,
        emailValidator,
        passwordValidator,
        alphaValidator,
      },
    }
  },
}
</script>
